import React from 'react';
import GuestHeader from './GuestHeader';
import { LandingBackground } from '@minifinder/resources/images';

const GuestFallback = () => {
    return (
        <React.Fragment>
            <GuestHeader />
            <div className="h-img-background" style={{ backgroundImage: `url(${LandingBackground})` }} />
            <div className="guest-fallback" />
        </React.Fragment>
    );
};

export default GuestFallback;
